var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoteleaddetail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "mr-24",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 1H15.6482C16.2514 1 16.8224 1.27227 17.2022 1.74098L21.054 6.49524C21.3425 6.8514 21.5 7.29587 21.5 7.75425V19C21.5 21.2091 19.7091 23 17.5 23H7.5C5.29086 23 3.5 21.2091 3.5 19V5C3.5 2.79086 5.29086 1 7.5 1ZM16.125 3.58854V6.4H18.4028L16.125 3.58854ZM7.5 3C6.39543 3 5.5 3.89543 5.5 5V19C5.5 20.1046 6.39543 21 7.5 21H17.5C18.6046 21 19.5 20.1046 19.5 19V8.4H16.125C15.0204 8.4 14.125 7.50457 14.125 6.4V3H7.5Z",
    fill: "#FF974A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteleaddetail);
export default __webpack_public_path__ + "static/media/note.leaddetail.b67925055ee2ea4a946e3aede0226432.svg";
export { ForwardRef as ReactComponent };